<template>
  <div class="main">
    <!-- 红字发票确认信息录入 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <el-icon @click="emits('changePage', 'redInvoice_home')"><Back /></el-icon>
        <el-breadcrumb separator-icon="arrowRight">
          <el-breadcrumb-item>红字发票业务</el-breadcrumb-item>
          <el-breadcrumb-item>红字发票确认信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="operate-main">
      <div class="common-box">
        <el-form ref="queryRef" :model="queryParams" :inline="true" label-width="140px" class="search-box">
          <el-row>
            <el-col :span="8">
              <el-form-item label="购/销方选择" prop="is_my">
                <el-select v-model="queryParams.is_my">
                  <el-option label="我是销售方" value="1" />
                  <el-option label="我是购买方" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="确认单状态" prop="isQueren">
                <el-select v-model="queryParams.isQueren">
                  <el-option label="全部" value="" />
                  <el-option label="无需确认" value="1" />
                  <el-option label="销方录入待购方确认" value="3" />
                  <el-option label="购方录入待销方确认" value="4" />
                  <el-option label="购销双方已确认" value="2" />
                  <el-option label="作废(销方录入购方否认)" value="5" />
                  <el-option label="作废(购方录入销方否认)" value="6" />
                  <el-option label="作废(超72小时未确认)" value="7" />
                  <el-option label="作废(发起方已撤销)" value="8" />
                  <el-option label="作废(确认后撤销)" value="9" />
                  <el-option label="作废(异常凭证)" value="10" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="对方纳税人名称" prop="buyer.name">
                <el-input v-model.trim="queryParams.buyer.name" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="开票日期起" prop="beginTime">
                <el-input v-model="queryParams.beginTime" placeholder="yyyy/mm/日" :readonly="true" suffix-icon="Calendar" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票日期止" prop="endTime">
                <el-input v-model="queryParams.endTime" placeholder="yyyy/mm/日" :readonly="true" suffix-icon="Calendar" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票状态" prop="kaijuStatus">
                <el-select v-model="queryParams.kaijuStatus">
                  <el-option label="请选择" value="" />
                  <el-option label="已开具" value="1" />
                  <el-option label="未开具" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="发票代码" prop="applyType">
                <el-select v-model="queryParams.applyType">
                  <el-option label="请选择" value="" />
                  <el-option label="销售方" value="1" />
                  <el-option label="购买方" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="width: 100%; margin-top: 20px; display: flex; justify-content: end">
          <el-button type="default" @click="resetQuery">重置</el-button>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </div>

        <div class="table-wrap">
          <el-table :data="tableData" :border="true">
            <el-table-column label="购销身份" min-width="120">
              <template #default="{ row }">
                <span>{{ row.applyType.substring(0, 3) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="对方纳税人名称" min-width="240">
              <template #default="{ row }">
                <span>{{ row.buyer?.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="纳税人识别号" min-width="200">
              <template #default="{ row }">
                <span>{{ row.buyer?.taxRegistrationNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="对应蓝票数电票号码" prop="code" min-width="200" />
            <el-table-column label="对应蓝票发票代码" min-width="150">
              <template #default="{ row }">
                <span>-</span>
              </template>
            </el-table-column>
            <el-table-column label="对应蓝票发票号码" min-width="150">
              <template #default="{ row }">
                <span>-</span>
              </template>
            </el-table-column>
            <el-table-column label="红字通知单编号" prop="number" min-width="200" />
            <el-table-column label="发票金额" prop="totalAmount" min-width="120">
              <template #default="{ row }">
                <span style="color: red">{{ Number(row.totalAmount ?? 0).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="发票税额" prop="totalTaxAmount" min-width="120">
              <template #default="{ row }">
                <span style="color: red">{{ Number(row.totalTaxAmount ?? 0).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="冲红原因" prop="checker" :formatter="getReason" min-width="120" />
            <el-table-column label="状态" min-width="180">
              <template #default="{ row }">
                <span>{{ getQuerenStatus(row.isQueren) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开具状态" prop="kaijuStatus" min-width="120">
              <template #default="{ row }">
                <span>{{ ['未开具', '已开具'][row.kaijuStatus] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="180px">
              <template #default="{ row }">
                <span>
                  <el-button type="primary" link @click="checkDetail(row)">查看</el-button>
                </span>
                <span v-show="row.kaijuStatus === 0">
                  <el-button type="primary" link @click="warn()">撤销</el-button>
                </span>
                <span v-show="row.kaijuStatus === 0">
                  <el-button type="primary" link @click="goHzkaipaio(row)">去开票</el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 查看红字发票 -->
      <hz-basic-dialog v-model="visible" :row="currentRow" />
    </div>
  </div>
</template>

<script setup name="RedInvoice/queren">
import { getRedInvoiceList } from '@/api/invoice';
import hzBasicDialog from '../cmp/hzBasicDialog.vue';

import useInvoiceStore from '@/store/modules/invoice';

const useInvoice = useInvoiceStore();
const emits = defineEmits(['changePage']);

const queryParams = reactive({
  is_my: '1',
  isQueren: '',
  buyer: {
    name: null,
  },
  beginTime: null,
  endTime: null,
  kaijuStatus: '',
  applyType: '1',
});
const queryRef = ref();
const tableData = ref([]);

const currentRow = ref({});

onMounted(() => {
  handleQuery();
});

function handleQuery() {
  const data = useInvoice.redInvoiceList;
  tableData.value = [...data].filter((item) => [1, 2].includes(item.isQueren));
}

function resetQuery() {
  queryRef.value && queryRef.value.resetFields();
}

//获取冲红
function getQuerenStatus(cellValue) {
  let str = '';
  const mapList = [
    { label: '无需确认', value: '1' },
    { label: '购方录入待销方确认', value: '4' },
    { label: '购销双方已确认', value: '2' },
    { label: '作废', value: '6' },
    { label: '销方录入待购方确认', value: '99' },
  ];
  mapList.forEach((item) => {
    if (item.value == cellValue) {
      str = item.label;
    }
  });
  return str;
}

//获取冲红原因
function getReason(row, column, cellValue) {
  return ['', '开票有误', '服务中止', '销货退回', '销售折让'][cellValue];
}

const visible = ref(false);
//点击查看
function checkDetail(row) {
  visible.value = true;
  currentRow.value = Object.assign({}, toRaw(row));
}

//去开票
function goHzkaipaio(row) {
  sessionStorage.setItem('hzkaipiao_id', row.id);
  emits('changePage', 'redInvoice_kaipiao');
}

//警告功能
function warn() {
  ElMessageBox.confirm('本系统为教学系统，暂不支持此功能', '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {});
}
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-size: 16px;
  background-color: #f6f7fb;
  display: flex;
  flex-direction: column;
  .header-block {
    flex: none;
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      column-gap: 0.1rem;
      > .bread {
        margin-inline-start: 0.1rem;
        font-weight: 600;
        color: #333;
      }
    }
  }
  .operate-main {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
    .common-box {
      box-sizing: border-box;
      width: 100%;
      padding: 30px 20px 20px;
      border-radius: 3px;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
      :deep(.search-box) {
        margin-top: 20px;
        .el-form-item {
          width: 100%;
          .el-form-item__label {
            white-space: nowrap;
          }
        }
      }

      .table-wrap {
        width: 100%;
        margin-top: 15px;
      }
    }
  }
}
</style>
